import type { remultStatic as RemultStatic } from "remult/src/remult-static";

export const remultStatic = (globalThis as any)[
  Symbol.for("remult-static1")
] as typeof RemultStatic;
